import { Component, Input } from '@angular/core';
import { fadeInOut } from 'src/app/animations/animations';


@Component({
    selector: 'app-extendable-card',
    templateUrl: './extendable-card.component.html',
    styleUrls: ['./extendable-card.component.scss'],
    animations: [
        fadeInOut
    ],
    imports: []
})
export class ExtendableCardComponent {

    @Input() headingText: string = '';
    @Input() visibleText: string = '';
    @Input() hiddenText: string = '';
    @Input() showText: string = 'Show more';
    @Input() hideText: string = 'Show less';
    @Input() show: boolean = false;
    @Input() id: string = 'extendable-card-id';

    public toggle(): void {
        this.show = !this.show;
    }

}
